module.exports = __webpack_public_path__ + "img/background-black.97ceff9a.jpg";